// extracted by mini-css-extract-plugin
export var relative = "styles-module--relative--1QUII";
export var container = "styles-module--container--dKpV2";
export var text = "styles-module--text--mXt9+";
export var withShadow = "styles-module--withShadow--hFhrE";
export var noMargins = "styles-module--noMargins--ARW8k";
export var centeredText = "styles-module--centeredText--y-Tn0";